import createNamedExpression from '../helpers/createNamedExpression';
/**
 * @internal Use {@link globalProperty} instead
 */
export var global = function () {
  return createNamedExpression('global', []);
};
